import CTA from '@maison/components/common/CTA';
import { isEmpty } from 'lodash-es';

export default {
  components: { CTA },

  props: {
    stores: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    displayNoResult: {
      type: Boolean,
      default: false,
    },
    followStoreLinkOnClick: {
      type: Boolean,
      default: true,
    },
    noResultTitle: {
      type: String,
      default: '',
    },
    noResultText: {
      type: String,
      default: '',
    },
    noResultCTA: {
      type: Object,
      default: null,
    },
  },

  computed: {
    hasStore() {
      return !isEmpty(this.stores);
    },
  },

  methods: {
    getFullAddress(store) {
      const address = [];

      address.push(store.address1);
      if (store.address2) {
        address.push(store.address2);
      }
      if (store.zip) {
        address.push(store.zip);
      }
      if (store.city) {
        address.push(store.city);
      }

      return address.join(', ');
    },

    storeClick(store) {
      this.$emit('storeClick', store);
    },

    storeLink(permalink) {
      return this.followStoreLinkOnClick ? permalink : '#';
    },
  },
};
